import { connect } from 'react-redux'
import Identity from './Identity.jsx'
import { getCollaborativeIndexationCreationFields } from '../../../../../../../redux/collaborativeIndexations/selectors'
import { updateCollaborativeIndexationFieldValue } from '../../../../../../../redux/collaborativeIndexations/actions'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
})

export const IdentityContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Identity)
